<template>
	<window-view title="Projekt" v-on="$listeners" style="width: 800px;" :actions="_actions">
		<tabs-view :tabs="_tabs" v-model="tab" style="margin-top: -10px;" />

		<panel-view v-show="tab == 'project'">
			<panel-sep-view>
				<grid-view :cols="['1fr', '4fr']">
					<input-view v-model="model.case_no" label="Sagnsnr" />
					<multi-view component="input-view" :tabs="languages" v-model="model.title" label="Title" />
				</grid-view>
				<grid-view :cols="['1fr', '1fr']">
					<select-view label="Type" v-model="model.contract_type_id" clear="Ryd" :options="[
						{
							label: 'Fagentreprise',
							value: 	1
						},
						{
							label: 'Hovedentreprise',
							value: 	2
						},
						{
							label: 'Partnering',
							value: 	3
						},
						{
							label: 'Råhusentreprise',
							value: 	4
						},
						{
							label: 'Storentreprise',
							value: 	6
						},
						{
							label: 'Totalentreprise',
							value: 	7
						}
					]" />
					<input-view label="Entreprisesum" v-model="model.contract_sum" type="number" :decimals="2" suffix="mio kr"></input-view>
				</grid-view>
			</panel-sep-view>
			<grid-view v-if="false" :cols="['1fr', '1fr']">
				<input-view label="Påbegyndt" v-model="model.started" :decimals="0"></input-view>
				<input-view label="Afsluttet" v-model="model.completed" :decimals="0"></input-view>
			</grid-view>
			<grid-view :cols="['1fr', '1fr']">
				<input-view label="Påbegyndt år" v-model="model.started_year" :decimals="0"></input-view>
				<select-view label="Påbegyndt måned" v-model="model.started_month" :options="_months" clear="Ryd" />
			</grid-view>
			<grid-view :cols="['1fr', '1fr']">
				<input-view label="Afsluttet år" v-model="model.completed_year" :decimals="0"></input-view>
				<select-view label="Afsluttet måned" v-model="model.completed_month" :options="_months" clear="Ryd" />
			</grid-view>
			<grid-view :cols="['1fr', '1fr']">
				<input-view label="By" v-model="model.city"></input-view>
				<select-view label="Land" v-model="model._embedded.country" clear="Ryd" :options="_countries" />
			</grid-view>
			<grid-view>
				<switch-view label="Publiseret" v-model="model.published" />
			</grid-view>
		</panel-view>

		<panel-view v-show="tab == 'description'">
			<panel-sep-view>
				<grid-view>
					<multi-view component="input-view" :tabs="languages" v-model="model.summary" label="Resume" type="text" :height="100" :chars="250" />
				</grid-view>
				<grid-view>
					<multi-view component="input-view" :tabs="languages" v-model="model.description" label="Beskrivelse" type="text" :height="300" :chars="1000" />
				</grid-view>
			</panel-sep-view>
		</panel-view>

		<panel-view v-show="tab == 'categories'">
			<categories-view v-model="model._embedded.categories" />
		</panel-view>

		<panel-view v-show="tab == 'professions'">
			<professions-view v-model="model._embedded.professions" />
		</panel-view>

		<panel-view v-show="tab == 'profiles'">
			<internal-people-view v-model="model._embedded.profiles" />
		</panel-view>

		<panel-view v-show="tab == 'advisors'">
			<people-view v-model="model._embedded.advisors" />
		</panel-view>

		<panel-view v-show="tab == 'contractor'">
			<grid-view>
				<panel-sep-view>
					<grid-view>
						<input-view label="Navn" v-model="model.contractor"></input-view>
					</grid-view>
					<grid-view :cols="['1fr', '1fr', '1fr']">
						<input-view label="Att" v-model="model.contract_person"></input-view>
						<input-view label="Telefon" v-model="model.contract_phone"></input-view>
						<input-view label="E-mail" v-model="model.contract_email"></input-view>
					</grid-view>
				</panel-sep-view>
			</grid-view>
			<panel-sep-view>
				<grid-view>
					<input-view label="Address" v-model="model.contract_address"></input-view>
				</grid-view>
				<grid-view :cols="['1fr', '1fr', '1fr']">
					<input-view label="Postnummer" v-model="model.contract_zip"></input-view>
					<input-view label="By" v-model="model.contract_city"></input-view>
					<select-view label="Land" v-model="model._embedded.contract_country" clear="Ryd" :options="_countries" />
				</grid-view>
			</panel-sep-view>
		</panel-view>

		<panel-view v-show="tab == 'photos'">
			<photos-view v-model="model._embedded.photos" />
		</panel-view>

		<panel-view v-show="tab == 'branches'">
			Branches
		</panel-view>

		<panel-view v-show="tab == 'web'">
			<panel-sep-view>
				<grid-view>
					<multi-view component="input-view" :tabs="languages" v-model="model.web" label="Indhold" type="text" :height="500" :chars="5000" />
				</grid-view>
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	export default {
		props: {
			id: {
				type: Number,
				default: null
			}
		},
		data() {
			return {
				tab: 'project',

				countries: [],

				model: {
					case_no: '',
					title: {},
					contract_type_id: null,
					contract_sum: '',
					started: '',
					completed: '',
					city: '',
					country_code: '',
					archived: false,
					published: false,
					summary: {},
					description: {},
					contractor: '',
					contract_person: '',
					contract_phone: '',
					contract_email: '',
					contract_address: '',
					contract_zip: '',
					contract_city: '',
					contract_country_code: '',

					// debug
					started_year: '',
					started_month: '',
					completed_year: '',
					completed_month: '',

					_embedded: {
						photos: [],
						profiles: [],
						advisors: [],
						categories: [],
						professions: [],
						country: null
					}
				},
				languages: [
					{
						label: 'Dansk',
						value: 'da'
					},
					{
						label: 'English',
						value: 'en'
					}
				]
			};
		},
		computed: {
			_countries() {
				return this.countries.map((item) => {
					return {
						label: item.label.da,
						value: item.code
					};
				});
			},
			_actions() {
				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							console.log('save', this, this.model);
							//const self = this;

							if (this.id) {
								if ((await this.axios.put(`/projects/${this.id}`, this.model)) !== null) {
									this.$store.dispatch('projects/update');
									return true;
								}
							} else {
								if ((await this.axios.post('/projects', this.model)) !== null) {
									this.$store.dispatch('projects/update');
									return true;
								}
							}
						}
					}
				];
			},
			_tabs() {
				return [
					{
						label:	'Projekt',
						value:	'project'
					},
					{
						label:	'Beskrivelse',
						value:	'description'
					},
					{
						label:	'Kategorier',
						value:	'categories'
					},
					{
						label:	'Professioner',
						value:	'professions'
					},
					{
						label:	'Profiler',
						value:	'profiles'
					},
					{
						label:	'Rådgivere',
						value:	'advisors'
					},
					{
						label:	'Bygherre',
						value:	'contractor'
					},
					{
						label:	'Fotografier',
						value:	'photos'
					},
					{
						label:	'Web',
						value:	'web'
					}/*,
					{
						label:	'Branches',
						value:	'branches'
					}*/
				];
			},
			_months() {
				return [
					{
						label: 'Januar',
						value: 1
					},
					{
						label: 'Februar',
						value: 2
					},
					{
						label: 'Marts',
						value: 3
					},
					{
						label: 'April',
						value: 4
					},
					{
						label: 'Maj',
						value: 5
					},
					{
						label: 'Juni',
						value: 6
					},
					{
						label: 'Juli',
						value: 7
					},
					{
						label: 'August',
						value: 8
					},
					{
						label: 'September',
						value: 9
					},
					{
						label: 'Oktober',
						value: 10
					},
					{
						label: 'November',
						value: 11
					},
					{
						label: 'December',
						value: 12
					}
				];
			}
		},
		async created() {
			this.countries = (await this.axios.get('/countries'));

			console.log(this.countries);

			console.log('project win', this.$attrs);

			// Load if editing
			if (this.id) {
				console.log('EDIT!!!');
				this.model = (await this.axios.get(`/projects/${this.id}`));
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>